/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_TechnicalInputs */



/**
* | output |
* | --- |
* | "Technical Issue" |
*
* @param {Manual_Qc_Type_TechnicalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_technical = /** @type {((inputs?: Manual_Qc_Type_TechnicalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_TechnicalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Probleme technique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Technisches Problem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Problema tecnico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Техническая проблема")
	if (locale === "es") return /** @type {LocalizedString} */ ("Problema técnico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("技术问题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("技術的な問題")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तकनीकी समस्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Problema técnico")
	return /** @type {LocalizedString} */ ("Technical Issue")
});